import { useTranslation } from "react-i18next";
import { IOutletContext } from "../utils/interfaces/IOutletContext";
import { useOutletContext } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../utils/redux/userSlice";
import AssistanceForm from "../components/AssistanceComponents/AssistanceForm/AssistanceForm.component";
import AssistanceGrid from "../components/AssistanceComponents/AssistanceGrid/AssistanceGrid.component";
import { Machine } from "../utils/models/Machine";
import { Assistance } from "../utils/models/Assistance";
import { ISelectOptions } from "aw-combobox";
import { GetAssistancesStatesOptions, GetAssistancesTypeOptions, getAssistanceTypesColor } from "../utils/const";
import { useTheme } from "../utils/contexts/ThemeContext";
import { formatDateTime } from "aw-date-functions";
import AssistencesSearchBar from "../components/AssistanceComponents/AssistencesSearchBar/AssistencesSearchBar.component";
import Calendar from "../components/Calendar/calendar";

const AsistancesModulePage = () => {
    const { t } = useTranslation();
    const [isNew, setIsNew] = useState(false)
    const [loading, setLoading] = useState(false)
    const [newEditDelObj, setNewEditDelObj] = useState(new Assistance())
    const [assistances, setAssistances] = useState<Assistance[]>([])
    const [assistanceFiltered, setAssistanceFiltered] = useState<Assistance[]>([])
    const [formLock, setFormLock] = useState(true)
    const [switchOption, setSwitchOption] = useState('calendar')
    const [showModal, setShowModal] = useState(false)

    const [allMachinesObj, setAllMachinesObj] = useState<ISelectOptions[]>([])
    const [allMachines, setAllMachines] = useState<Machine[]>([])

    const [machinesOptions, setMachinesOptions] = useState<any[]>([])
    const [filterMachineSelected, setFilterMachineSelected] = useState<ISelectOptions | null>(null)

    const typeOptions = GetAssistancesTypeOptions()
    const [stateSelected, setStateSelected] = useState<ISelectOptions | null>(null)

    const statesOptions = GetAssistancesStatesOptions()

    const [allUsersObj, setAllUsersObj] = useState<ISelectOptions[]>([])
    const [selectedUser, setSelectedUser] = useState<ISelectOptions | null>(null)

    const context: IOutletContext = useOutletContext();

    const user = useSelector(selectUser)
    const theme = useTheme()

    let incrementalId = 16

    useEffect(() => {
        getAllUsersAux()
        getAllMachinesAux()
    }, [])

    const randomNumber = () => {
        return parseInt((Math.random() * 500).toFixed(0))
    }

    const addDays = (date: Date, days: number): Date => {
        const result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    const assistancesFiltered = assistances.filter((assistance) => {
        return (
            (filterMachineSelected === null || assistance.machineId === filterMachineSelected.value) &&
            (stateSelected === null || assistance.type === stateSelected?.value) &&
            (selectedUser === null || assistance.userId === selectedUser?.value)
        );
    });


    useEffect(() => {
        const date = new Date()
        const assistances: Assistance[] = [
            { id: 1, machineId: 1, installation: 'Awayter', userId: 1, title: 'Machine startup', description: 'Desc 1', type: 0, stateId: 2, canteen_name: 'Awayter', assistance_date: addDays(date, -13), imagesFolder: `AW_${formatDateTime(date)}-${randomNumber}` },
            { id: 2, machineId: 2, installation: 'Awayter', userId: 2, title: 'Machine repair', description: 'Desc 2', type: 1, stateId: 2, canteen_name: 'Awayter', assistance_date: addDays(date, -9), imagesFolder: `AW_${formatDateTime(date)}-${randomNumber}` },
            { id: 3, machineId: 3, installation: 'Awayter', userId: 3, title: 'Monthly maintenance', description: 'Desc 3', type: 3, stateId: 2, canteen_name: 'Awayter', assistance_date: addDays(date, -6), imagesFolder: `AW_${formatDateTime(date)}-${randomNumber}` },
            { id: 4, machineId: 4, installation: 'Awayter', userId: 4, title: 'Machine startup', description: 'Desc 4', type: 0, stateId: 2, canteen_name: 'Awayter', assistance_date: addDays(date, -3), imagesFolder: `AW_${formatDateTime(date)}-${randomNumber}` },
            { id: 5, machineId: 5, installation: 'Awayter', userId: 5, title: 'Machine startup', description: 'Desc 5', type: 0, stateId: 2, canteen_name: 'Awayter', assistance_date: addDays(date, -1), imagesFolder: `AW_${formatDateTime(date)}-${randomNumber}` },
            { id: 6, machineId: 6, installation: 'Awayter', userId: 6, title: 'Machine startup', description: 'Desc 6', type: 0, stateId: 1, canteen_name: 'Awayter', assistance_date: date, imagesFolder: `AW_${formatDateTime(date)}-${randomNumber}` },
            { id: 7, machineId: 7, installation: 'Awayter', userId: 7, title: 'Machine startup', description: 'Desc 7', type: 0, stateId: 0, canteen_name: 'Awayter', assistance_date: addDays(date, 1), imagesFolder: `AW_${formatDateTime(date)}-${randomNumber}` },
            { id: 8, machineId: 8, installation: 'Awayter', userId: 8, title: 'Machine repair', description: 'Desc 8', type: 1, stateId: 0, canteen_name: 'Awayter', assistance_date: addDays(date, 3), imagesFolder: `AW_${formatDateTime(date)}-${randomNumber}` },
            { id: 9, machineId: 9, installation: 'Awayter', userId: 9, title: 'Machine repair', description: 'Desc 9', type: 1, stateId: 0, canteen_name: 'Awayter', assistance_date: addDays(date, 5), imagesFolder: `AW_${formatDateTime(date)}-${randomNumber}` },
            { id: 10, machineId: 10, installation: 'Awayter', userId: 1, title: 'Machine repair', description: 'Desc 10', type: 1, stateId: 0, canteen_name: 'Awayter', assistance_date: addDays(date, 5), imagesFolder: `AW_${formatDateTime(date)}-${randomNumber}` },
            { id: 11, machineId: 1, installation: 'Awayter', userId: 2, title: 'Machine repair', description: 'Desc 11', type: 1, stateId: 0, canteen_name: 'Awayter', assistance_date: addDays(date, 7), imagesFolder: `AW_${formatDateTime(date)}-${randomNumber}` },
            { id: 12, machineId: 2, installation: 'Awayter', userId: 3, title: 'Machine startup', description: 'Desc 12', type: 0, stateId: 0, canteen_name: 'Awayter', assistance_date: addDays(date, 9), imagesFolder: `AW_${formatDateTime(date)}-${randomNumber}` },
            { id: 13, machineId: 1, installation: 'Awayter', userId: 4, title: 'Monthly maintenance', description: 'Desc 13', type: 3, stateId: 0, canteen_name: 'Awayter', assistance_date: addDays(date, 12), imagesFolder: `AW_${formatDateTime(date)}-${randomNumber}` },
            { id: 14, machineId: 2, installation: 'Awayter', userId: 5, title: 'Monthly maintenance', description: 'Desc 14', type: 3, stateId: 0, canteen_name: 'Awayter', assistance_date: addDays(date, 12), imagesFolder: `AW_${formatDateTime(date)}-${randomNumber}` },
            { id: 15, machineId: 1, installation: 'Awayter', userId: 6, title: 'Monthly maintenance', description: 'Desc 15', type: 3, stateId: 0, canteen_name: 'Awayter', assistance_date: addDays(date, 12), imagesFolder: `AW_${formatDateTime(date)}-${randomNumber}` },
        ]

        setAssistances(assistances)
        setAssistanceFiltered(assistances)
    }, [allMachines])


    const getAllUsersAux = () => {
        const mockUsers: ISelectOptions[] = []
        for (let i = 1; i <= 10; i++) {
            mockUsers.push({ label: `User ${i}`, value: i })
        }
        setAllUsersObj(mockUsers)
    }

    const getAllMachinesAux = () => {
        let machines: ISelectOptions[] = [
            { label: 'Machine 1', value: 1 },
            { label: 'Machine 2', value: 2 },
            { label: 'Machine 3', value: 3 },
            { label: 'Machine 4', value: 4 },
            { label: 'Machine 5', value: 5 },
            { label: 'Machine 6', value: 6 },
            { label: 'Machine 7', value: 7 },
            { label: 'Machine 8', value: 8 },
            { label: 'Machine 9', value: 9 },
            { label: 'Machine 10', value: 10 },
        ]
        setMachinesOptions(machines)
        setAllMachinesObj(machines)
    }

    useEffect(() => {
        context.setState(t('InterventionTracking'))
    })

    const newAssistanceClick = () => {
        let newAssistance = new Assistance()
        newAssistance.id = incrementalId++
        setNewEditDelObj(newAssistance)
        setFormLock(false)
        setIsNew(true)
        setShowModal(true)
    }

    const editClick = (a: Assistance) => {
        setFormLock(false)
        setIsNew(false)
        setNewEditDelObj(a)
        setShowModal(true)
    }

    const save = (a: Assistance) => {
        setAssistances((prev) => {
            const exists = prev.find((x) => x.id === a.id);
            if (exists) {
                // editar
                return prev.map((x) => (x.id === a.id ? a : x));
            } else {
                // nuevo
                return [...prev, a];
            }
        });
        setShowModal(false);
    }

    const onEventUpdateDate = (a: Assistance) => {
        setAssistances(prev =>
            prev.map(assistance =>
                assistance.id == a.id
                    ? { ...assistance, assistance_date: new Date(a.assistance_date) }
                    : assistance
            )
        )
    }

    return (
        <>
            <div className="d-flex flex-column" style={{ height: '90vh' }}>
                <AssistanceForm showModal={showModal} assistanceAux={newEditDelObj} edit={isNew} onSave={save}
                    formLock={formLock} machineOptions={allMachinesObj} stateOptions={statesOptions} usersOptions={allUsersObj} typesOptions={typeOptions} onHide={() => setShowModal(false)}
                />
                <div className='row border-0 ms-2 me-2' style={{ maxWidth: '100%' }}>
                    <div className='col-12 col-md-12 p-1' style={{ color: 'var(--text-primary)' }}>
                        <AssistencesSearchBar
                            options1={machinesOptions}
                            options2={typeOptions}
                            options3={allUsersObj}
                            selectedOption1={filterMachineSelected}
                            selectedOption2={stateSelected}
                            selectedOption3={selectedUser}
                            onClickNew={newAssistanceClick}
                            onChangeSelected1={setFilterMachineSelected}
                            onChangeSelected2={setStateSelected}
                            onChangeSelected3={setSelectedUser}
                            rounded="rounded-1"
                            dark={theme.theme === "dark" ? true : false}
                            containerColor="var(--background-secondary)"
                            classNameSuccess="btn-Custom btn-IDGreen"
                            defaultIni={""}
                            defaultFin={""}
                            role={0}
                            disableMachineSelect={false}
                            onChangeDates={() => { }}
                            onClickReload={() => { }}
                            onSwitchChange={setSwitchOption}
                        />
                    </div>
                </div>

                <div className='row border-0 ms-2 me-2 h-100' style={{ maxWidth: '100%' }}>
                    {switchOption == 'list'
                        ? <div className='col-12 col-md-12 p-1'>
                            <AssistanceGrid
                                assistances={assistancesFiltered}
                                loading={loading}
                                typesOptions={typeOptions}
                                statesOptions={statesOptions}
                                machinesOptions={machinesOptions}
                                userOptions={allUsersObj}
                                onDeleteClick={() => null}
                                onEditClick={editClick}
                            />
                        </div>
                        : <div className='col-12 col-md-12 p-1 flex-grow-1'>
                            <div className="cardContainer py-2 h-100">
                                <Calendar
                                    events={assistancesFiltered.map((a) => ({
                                        id: a.id,
                                        title: a.title,
                                        date: a.assistance_date.toISOString(),
                                        allDay: true,
                                        color: getAssistanceTypesColor(a.type),
                                        extendedProps: a
                                    }))}
                                    onEventClick={(a: Assistance) => editClick(a)}
                                    onEventUpdateDate={(a: Assistance) => onEventUpdateDate(a)}
                                />
                            </div>

                        </div>
                    }
                </div>
            </div>
        </>
    )
}

export default AsistancesModulePage;
